import axios from 'axios';
import _get from 'lodash/get';
import * as types from '../constants/ActionTypes';
import { trackPage } from '../../lib/analytics-helper';
import Page from '../../lib/page';
import poll from '../../lib/poll';
import { loadChatIneligibleModalContainer, closeChatIneligibleModalContainer } from '../../contactUs/actions/action-chat-ineligible-modal';

function setChatBotLoaded() {
  return { type: types.SET_CHAT_BOT_LOADED };
}

function setChatBotError() {
  return { type: types.SET_CHAT_BOT_ERROR };
}

function chatBotEligibleCheck() {
  return (dispatch) => {
    axios.get('/smarthelp/chat-bot-eligibility').then((response) => {
      if (response && response.data && response.data.chatBotInfo && response.data.chatBotInfo.chatEnabled) {
        setTimeout(() => {
          trackPage({ id: 'chatBot' });
          dispatch(setChatBotLoaded());
          // eslint-disable-next-line no-undef
          nodeChat.show('chatBot', 'c2cip');
        }, 200);
      }
    }).catch(() => {
      dispatch(setChatBotError());
    });
  };
}

const validateNodeChat = () => {
  if (!window.nodeChat) {
    return Promise.reject(false);
  }
  return Promise.resolve(window.nodeChat);
};

// displaying chatBot
function displayChatBot() {
  return (dispatch, getState) => {
    const chatClicked = _get(getState(), 'chatBotFAQ.chatBotClicked');
    const isChatBotEnabled = Page.getIsChatBotEnabled();
    const isLoggedIn = Page.isLoggedIn();
    if (isLoggedIn && typeof chatClicked === 'boolean' && chatClicked) {
      if (isChatBotEnabled) {
        dispatch(closeChatIneligibleModalContainer()); // making chatClicked false
        return poll(validateNodeChat, 15, 1500)
          .then(() => {
          // eslint-disable-next-line no-undef
            nodeChat.show('chatBot', 'GENPOOL');
          })
          .catch(() => {});
      }
      dispatch(loadChatIneligibleModalContainer());
    }
    return { type: types.CHATBOT_FAQ_DISPLAY_CHECKER };
  };
}

module.exports = {
  chatBotEligibleCheck,
  displayChatBot,
};
